import { TablePagination } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';

import React from 'react';

const theme = createTheme({
  overrides: {
    MuiTablePagination: {
      root: {
        margin: '2px'
      },
      toolbar: {
        // height: '34px',
        minHeight: '34px',
      },
    }
  }
});

const Paginacao = ({rowsPerPageOptions, rowsPerPage, count, currentPage, paginate}) => {
  return (
    <MuiThemeProvider theme={theme}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component='div'
        count={count}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        backIconButtonProps={{
          'aria-label': 'Próximos',
        }}
        nextIconButtonProps={{
          'aria-label': 'Anteriores',
        }}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        onChangePage={paginate}
      />
    </MuiThemeProvider>
  );
};

export default Paginacao;
